module.exports = __webpack_public_path__ + "static/media/processing.c4879420.gif";